import {
  COLLECTIONS_LOAD_FILTER_DATA_BEGIN,
  COLLECTIONS_LOAD_FILTER_DATA_SUCCESS,
  COLLECTIONS_LOAD_FILTER_DATA_FAILURE,
  COLLECTIONS_LOAD_FILTER_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadFilterData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_FILTER_DATA_BEGIN,
    });
    const { projectId, collectionName, finderId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/collection/item/filterdata/${collectionName}/${finderId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_LOAD_FILTER_DATA_SUCCESS,
              data: res.data,
              collection: args.collectionName,
            });
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_LOAD_FILTER_DATA_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_FILTER_DATA_FAILURE,
            data: { error: err },
          });

          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`);

          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadFilterDataError() {
  return {
    type: COLLECTIONS_LOAD_FILTER_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_FILTER_DATA_BEGIN:
      return {
        ...state,
        loadFilterDataPending: true,
        loadFilterDataError: null,
      };

    case COLLECTIONS_LOAD_FILTER_DATA_SUCCESS:
      let newSelectedCollection = state.selectedCollection;
      let filter_items = action.data;

      if (action.collection && action.collection.collectionName) {
        newSelectedCollection = action.collection;
      }
      return {
        ...state,
        loadFilterDataPending: false,
        loadFilterDataError: null,
        selectedCollection: newSelectedCollection,
        filter_items,
      };

    case COLLECTIONS_LOAD_FILTER_DATA_FAILURE:
      return {
        ...state,
        loadFilterDataPending: false,
        loadFilterDataError: action.data.error,
      };

    case COLLECTIONS_LOAD_FILTER_DATA_DISMISS_ERROR:
      return {
        ...state,
        loadFilterDataError: null,
      };

    default:
      return state;
  }
}
